import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { from, switchMap } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { SanctumService } from 'src/app/services/sanctum.service';
import { AuthHeaderService } from 'src/app/services/auth-header.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-testebtn',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './testebtn.component.html',
  styleUrls: ['./testebtn.component.scss']
})
export class TestebtnComponent {

  loading = false;
  result: any = null;
  error: string | null = null;

  // Hardcoded do webhook recebido
  private storeId = 1;
  private commentId = '18000060554947294';
  private igUserId = '17841451256341069'; // IG user ID do @slick_sell (conta da marca)
  private mediaIdCaption = '18131228677584722'; // media_id do webhook sem comment_id (menção na legenda)

  constructor(
    private http: HttpClient,
    private sanctum: SanctumService,
    private authHeaderService: AuthHeaderService
  ) {}

  testMentionedComment(): void {
    this.loading = true;
    this.result = null;
    this.error = null;

    const url = `${environment.serverUrl}/admin/store/${this.storeId}/instagram/mentions/comment`
      + `?comment_id=${this.commentId}&ig_user_id=${this.igUserId}`;

    from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(opts => this.http.get<any>(url, opts))
    ).subscribe({
      next: (res) => {
        this.result = { via_mentioned_comment: res };
        this.loading = false;
      },
      error: (err) => {
        this.error = JSON.stringify(err?.error ?? err, null, 2);
        this.loading = false;
      }
    });
  }

  testMentionedMedia(): void {
    this.loading = true;
    this.result = null;
    this.error = null;

    const url = `${environment.serverUrl}/admin/store/${this.storeId}/instagram/mentions/media-details`
      + `?media_id=${this.mediaIdCaption}&ig_user_id=${this.igUserId}`;

    from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(opts => this.http.get<any>(url, opts))
    ).subscribe({
      next: (res) => { this.result = { via_mentioned_media: res }; this.loading = false; },
      error: (err) => { this.error = JSON.stringify(err?.error ?? err, null, 2); this.loading = false; }
    });
  }

  testLinkedPage(): void {
    this.loading = true;
    this.result = null;
    this.error = null;

    const url = `${environment.serverUrl}/admin/store/${this.storeId}/instagram/ig-linked-page`
      + `?ig_user_id=${this.igUserId}`;

    from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(opts => this.http.get<any>(url, opts))
    ).subscribe({
      next: (res) => { this.result = { ig_linked_page: res }; this.loading = false; },
      error: (err) => { this.error = JSON.stringify(err?.error ?? err, null, 2); this.loading = false; }
    });
  }

  testDirectComment(): void {
    this.loading = true;
    this.result = null;
    this.error = null;

    const url = `${environment.serverUrl}/admin/store/${this.storeId}/instagram/mentions/comment`
      + `?comment_id=${this.commentId}&ig_user_id=${this.igUserId}&direct=1`;

    from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(opts => this.http.get<any>(url, opts))
    ).subscribe({
      next: (res) => {
        this.result = { via_direct_comment: res };
        this.loading = false;
      },
      error: (err) => {
        this.error = JSON.stringify(err?.error ?? err, null, 2);
        this.loading = false;
      }
    });
  }

  testCommentViaMentions(): void {
    this.loading = true;
    this.result = null;
    this.error = null;

    const url = `${environment.serverUrl}/admin/store/${this.storeId}/instagram/test-comment-mentions`;

    from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(opts => this.http.post<any>(url, {}, opts))
    ).subscribe({
      next: (res) => {
        this.result = { test_comment_mentions: res };
        this.loading = false;
      },
      error: (err) => {
        this.error = JSON.stringify(err?.error ?? err, null, 2);
        this.loading = false;
      }
    });
  }

  private carouselMediaId = '17940679212230410'; // carousel carousel mencionado

  testCarouselChildren(): void {
    this.loading = true;
    this.result = null;
    this.error = null;

    const url = `${environment.serverUrl}/admin/store/${this.storeId}/instagram/test-carousel-children`
      + `?media_id=${this.carouselMediaId}&ig_user_id=${this.igUserId}`;

    from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(opts => this.http.get<any>(url, opts))
    ).subscribe({
      next: (res) => { this.result = res; this.loading = false; },
      error: (err) => {
        this.error = JSON.stringify(err?.error ?? err, null, 2);
        this.loading = false;
      }
    });
  }
}
